module.exports = __webpack_public_path__ + "img/logo-golden.5c9665ba.png";